import { Select, SelectProps, Spin } from 'antd';
import * as React from 'react';
import Api from '../../../services/Api';
import debounce from 'lodash-es/debounce';
import { LoadingOutlined } from '@ant-design/icons';
import { set } from 'mobx';
import { useTranslation } from 'react-i18next';

interface FCProps {
  value?: string;
  onChange?: (value: string) => void;
}

const CategorySearch: React.FC<FCProps> = ({ onChange, value }) => {
  const [data, setData] = React.useState<SelectProps['options']>([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const { t } = useTranslation();

  const handleSearch = React.useMemo(
    () =>
      debounce(async (newValue: string) => {
        if (newValue.length < 2) {
          return;
        }

        setLoading(true);

        let searchResult = await Api.findCategoryName(newValue);

        let subcategoriesData = [];

        searchResult.data.forEach((category) => {
          subcategoriesData.push({
            value: category.name,
            label: category.name
          });
        });

        setData(subcategoriesData);

        setLoading(false);
      }, 1200),
    []
  );

  const handleChange = React.useCallback(
    (newValue: string) => {
      onChange(newValue);
    },
    [onChange]
  );

  return (
    <Select
      showSearch
      placeholder={t('Type something to start the search')}
      loading={loading}
      value={value}
      defaultActiveFirstOption={false}
      filterOption={false}
      onSearch={(searchValue) => {
        setLoading(true);
        setData([]);
        handleSearch(searchValue);
      }}
      onSelect={handleChange}
      notFoundContent={
        loading ? (
          <div className="flex justify-center">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            />
          </div>
        ) : null
      }
      options={data || []}
    />
  );
};

export default CategorySearch;
